import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';
// ...



import wixAnimations from 'wix-animations';

let firstTextIndex = 0;
let secondTextIndex = 0;
const typingText1 = "@Alexandre Peut-on remplacer l'image principale par autre chose ?"
const typingText2 = "@Alexandre C'est super. Merci."
const speed = 60
let firstTextPreviousCharWasBlank = false;
let secondTextPreviousCharWasBlank = false;
let DefaultTextDissapears = wixAnimations.timeline()
let ScaleSendIconTimeline = wixAnimations.timeline()
let LouisMsg1Timeline = wixAnimations.timeline()
let UpdateImgTimeline = wixAnimations.timeline()
let AleksanderMsgTimeline = wixAnimations.timeline()
let LouisLastMsgTimeline = wixAnimations.timeline()
let timeout

$w.onReady(function () {
    $w('#typingTextbox').text = ""
    setTimelineAnimations();
    resetAnimation();

    biEvents()

})

function setTimelineAnimations() {
    DefaultTextDissapears
        .add($w('#DefaultText'), { duration: 100, opacity: 0 })

    ScaleSendIconTimeline
        .add($w('#sendButton'), { duration: 100, scale: 1.2, easing: 'easeInOutSine', delay: 600 })
        .add($w('#DefaultText'), { duration: 100, opacity: 1 })
        .add($w('#sendButton'), { duration: 200, scale: 1, easing: 'easeInOutSine' })

    LouisMsg1Timeline
        .add($w('#bg1'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 200)
        .add($w('#1message'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 200)
        .add($w('#bg1'), { duration: 300, opacity: 0.5, easing: 'easeInOutSine' }, 1300)
        .add($w('#1message'), { duration: 300, opacity: 0.5, easing: 'easeInOutSine' }, 1300)
     

    UpdateImgTimeline
        .add($w('#selected'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 150)
        .add($w('#img1'), { duration: 500, opacity: 0, easing: 'easeInOutSine' }, 150)
        .add($w('#img3'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 1500)
       

    AleksanderMsgTimeline
        .add($w('#bg1'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 700)
        .add($w('#1message'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 700)
        .add($w('#bg1'), { duration: 400, opacity: 0, easing: 'easeInOutSine' }, 1700)
        .add($w('#2message'), { duration: 400, opacity: 1, easing: 'easeInOutSine' }, 1700)
        .add($w('#bg2'), { duration: 400, opacity: 1, easing: 'easeInOutSine' }, 1700)
        .add($w('#bg2'), { duration: 300, opacity: 1, easing: 'easeInOutSine', delay: 1000 }, 1700)

    LouisLastMsgTimeline
        .add($w('#3message'), { duration: 300, opacity: 1, easing: 'easeInOutSine' })
        .add($w('#bg2'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 0)
        .add($w('#bg3'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 0)
        .add($w('#bg3'), { duration: 1000, opacity: 1, easing: 'easeInOutSine' }, 1900)
}

 //resets running text between the animations//
function clearTypingText() {
    clearTimeout(timeout);
    setTimeout(() => {
        $w('#typingTextbox').text = ""
    }, 600)
}
//--------//


 //resets running text on container vieawport leave//
function viewportLeaveClearTypingText() {
    clearTimeout(timeout);
    setTimeout(() => {
        $w('#typingTextbox').text = ""
    },0)
}
 //---------//

function typing() {
    DefaultTextDissapears.replay()
    if (firstTextIndex < typingText1.length) {
        if (typingText1.charAt(firstTextIndex) === " ") {
            firstTextPreviousCharWasBlank = true
        } else {
            if (firstTextPreviousCharWasBlank === true) {
                $w('#typingTextbox').text += " " + typingText1.charAt(firstTextIndex)
                firstTextPreviousCharWasBlank = false
            } else {
                $w('#typingTextbox').text += typingText1.charAt(firstTextIndex)
            }
        }
        firstTextIndex++
        timeout = setTimeout(typing, speed)

    } else {

        clearTypingText();

        ScaleSendIconTimeline.replay();
        ScaleSendIconTimeline.onComplete(() => {
            LouisMsg1Timeline.replay()
        })
        LouisMsg1Timeline.onComplete(() => {
            UpdateImgTimeline.replay()
        })
        UpdateImgTimeline.onComplete(() => {

            AleksanderMsgTimeline.replay()
        })
        AleksanderMsgTimeline.onComplete(() => {

            typing2()
        })
    }
}

function typing2() {
    DefaultTextDissapears.replay()
    if (secondTextIndex < typingText2.length) {
        if (typingText2.charAt(secondTextIndex) === " ") {
            secondTextPreviousCharWasBlank = true
        } else {
            if (secondTextPreviousCharWasBlank === true) {
                $w('#typingTextbox').text += " " + typingText2.charAt(secondTextIndex)
                secondTextPreviousCharWasBlank = false
            } else {
                $w('#typingTextbox').text += typingText2.charAt(secondTextIndex)
            }
        }
        secondTextIndex++
        timeout = setTimeout(typing2, speed);
    } else {
        ScaleSendIconTimeline.replay();

        clearTypingText();
        ScaleSendIconTimeline.onComplete(() => {
            LouisLastMsgTimeline.replay()
        })
        LouisLastMsgTimeline.onComplete(() => {
            console.log('LouisLastMsgTimeline compleate')
            resetAnimation();
            typing();
        })
    }

}


 //resets animations on container vieawport leave//
function resetAnimation() {
    firstTextIndex = 0;
    secondTextIndex = 0;
    wixAnimations.timeline()
        .add($w('#img1'), { duration: 300, opacity: 1, easing: 'easeInOutSine' }, 0)
        .add($w('#bg3'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .add($w('#bg1'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .add($w('#bg2'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .add($w('#selected'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 0)
        .add($w('#img3'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 0)
        .add($w('#1message'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .add($w('#2message'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .add($w('#3message'), { duration: 300, opacity: 0, easing: 'easeInOutSine' }, 200)
        .replay()
}
 //--------//



export function box199_viewportEnter(event) {
	typing()
}

export function box199_viewportLeave(event) {

    viewportLeaveClearTypingText()
    resetAnimation()
    ScaleSendIconTimeline.pause()
    LouisMsg1Timeline.pause()
    UpdateImgTimeline.pause()
    AleksanderMsgTimeline.pause()
    LouisLastMsgTimeline.pause()

}

//-------hover innteraction-------//
let fadeOptionsHover = {
    "duration": 200

};

export function box135_mouseIn(event) {
    $w('#victoriaDevine').show("fade", fadeOptionsHover)
    $w('#name').show("fade", fadeOptionsHover)
    $w('#job').show("fade", fadeOptionsHover)

}

export function box135_mouseOut(event) {
    $w('#victoriaDevine').hide("fade", fadeOptionsHover)
    $w('#name').hide("fade", fadeOptionsHover)
    $w('#job').hide("fade", fadeOptionsHover)
}
//--------------//




//------bi------//
function biEvents() {
    //Start / Finish navigation
    fireBIEvent(110, 2506, {})
    $w('#imageX108').onViewportEnter(() => {
        fireBIEvent(110, 2507, {})
    })

    //cta buttons
    $w('#box207').onClick(() => {
        const biFields = {
            cta_name: 'Get Started'
        }
        fireBIEvent(110, 2505, biFields)
    })

    $w('#box202').onClick(() => {
        const biFields = {
            cta_name: 'Start Creating'
        }
        fireBIEvent(110, 2505, biFields)
    })

    //start collaborating
    $w('#box200').onClick(() => {
        const biFields = {
            cta_loc: $w('#button44').link
        }
        fireBIEvent(110, 2501, biFields)
    })
    $w('#box203').onClick(() => {
        const biFields = {
            cta_loc: $w('#button50').link
        }
        fireBIEvent(110, 2501, biFields)
    })
    $w('#box204').onClick(() => {
        const biFields = {
            cta_loc: $w('#button52').link
        }
        fireBIEvent(110, 2501, biFields)
    })
    $w('#box205').onClick(() => {
        const biFields = {
            cta_loc: $w('#button32').link
        }
        fireBIEvent(110, 2501, biFields)
    })

    $w('#box206').onClick(() => {
        const biFields = {
            cta_loc: $w('#button7').link
        }
        fireBIEvent(110, 2501, biFields)
    })

    $w('#box201').onClick(() => {
        const biFields = {
            cta_loc: $w('#button30').link
        }
        fireBIEvent(110, 2501, biFields)
    })
    //watch video tutorial
    $w('#text141').onClick(() => {
        const biFields = {
            full_video_length: 225,
            video_name: 'Collaborating in real time with concurrent editing'
        }
        fireBIEvent(110, 2502, biFields)
        wixWindow.openLightbox('Lightbox fold2')
    })

    $w('#text144').onClick(() => {
        const biFields = {
            full_video_length: 95,
            video_name: 'Communicate on the canvas with live comments'
        }
        fireBIEvent(110, 2502, biFields)
        wixWindow.openLightbox('Lightbox fold3')
    })

    $w('#text88').onClick(() => {
        const biFields = {
            full_video_length: 426,
            video_name: 'Assign and manage roles and Permissions'
        }
        fireBIEvent(110, 2502, biFields)
        wixWindow.openLightbox('Lightbox fold4')
    })

    $w('#text881').onClick(() => {
        const biFields = {
            full_video_length: 121,
            video_name: 'Create, manage and share design libraries'
        }
        fireBIEvent(110, 2502, biFields)
        wixWindow.openLightbox('Lightbox fold5')
    })
    $w('#text889').onClick(() => {
        const biFields = {
            full_video_length: 297,
            video_name: 'Set up a team account'
        }
        fireBIEvent(110, 2502, biFields)
        wixWindow.openLightbox('Lightbox fold5')
    })
}

